export const AUTH_TIMEOUT_BROADCAST_CHANNEL = 'auth-timeout-broadcast-channel'
export const authTimeoutTimerStart = 60
export const ONE_MINUTE_IN_MILLISECONDS = 60000
export const FIFTEEN_MINUTES_IN_MILLISECONDS = 900000

// Table
export const DEFAULT_CELL_HEIGHT = '36px'

// Client Table
export const SERVICE_LINE_DISPLAY_LIMIT = 3
// * Rows per page should probably be based on maximum screen height
// * ie set high for fewer network requests and to ensure that the "first page" is always full
// * or set based on screen height
export const ROWS_PER_PAGE = 40

// Cropper
export const CROPPER_MAX_ZOOM = 10
export const CROPPER_MIN_ZOOM = 0.1
export const DEFAULT_CROPPER_MAX_FILE_SIZE = 2000000 // 2MB
export const DEFAULT_CROPPER_WIDTH = '321px'

// Quasar Layout
export const QUASAR_LAYOUT_Z_INDEX = 2000
export const QUASAR_DRAWER_Z_INDEX = 3000

// AAP Exports
export const AAP_REPORTS_EXPORT_MAX_PERCENT = 1
export const BASE_GUID = '00000000-0000-0000-0000-000000000000'

export const OVERALL_LEVEL_OF_ANALYSIS = {
  id: BASE_GUID,
  description: 'Overall',
  updatePlan: false,
  planType: null,
  subPlans: null,
}

// Files
export const ONE_HUNDRED_MB = 104857600
export const FIVE_HUNDRED_MB = ONE_HUNDRED_MB * 5
export const MAX_TEXT_AREA_LENGTH = 1000

// COLORS
export const OAppThemeColors = [
  // * Business Colors
  'ba-808080',
  'ba-828282',
  'ba-primary',
  'ba-primary-light', // set to same as primary until get approval on changing colors
  'ba-secondary',
  'ba-tertiary',
  'ba-donut-label',
  'ba-positive',
  'ba-negative',
  'ba-darkGray',
  'ba-secondaryBluegreen',
  'ba-secondaryGray',
  'ba-subtleGrayBack',
  'ba-chartBlue',
  'ba-chartDarkGray',
  'ba-segment-inactive',
  'ba-dropdownBacker',
  'ba-menuRules',
  'ba-wht-red',
  'ba-two-peach',
  'ba-pac-pink',
  'ba-nat-ind-golden-rod',
  'ba-blk-blue',
  'hover-row-lt-blue',
  'ba-asi-violet',
  'ba-blue-teal',
  'ba-brand-pc-wht-red',
  'ba-50-dark-gray',
  'ba-e3e3e3',
  'ba-pv-hires',
  'ba-iwd-hires',
  'ba-iwd-applicants',
  'ba-under-audit',
  'ba-update-plan',
  'ba-required-red',
  'ba-primary-disabled-bg',
  'ba-primary-disabled-text-color',
  'ba-context-label',
  'ba-new-notification',

  // * Unofficial Colors
  'accent',
  'dark',
  'positive',
  'negative',
  'info',
  'warning',
] as const

// windiCSS required this
export const windiCSSThemeColors = OAppThemeColors.reduce(
  (allColors, currentColor: string) => {
    allColors[currentColor] = `var(--${currentColor})`
    return allColors
  },
  {} as Record<string, string>
)
// END COLORS

export const LESS_THAN_ONE_PERCENT_STRING = '< 1%'

// BREAKPOINTS
// breakpoints multiplied by 0.75
// harder to switch from desktop to tablet modes by zooming alone
// but keeps mobile styling as an option for users that want to view the site at extreme zoom levels
export const breakpoints = {
  // mobile: '390px',
  mobile: '293px',
  // tablet: '768px',
  tablet: '576px',
  // desktop: '1280px',
  desktop: '960px',
  // bigDesktop: '1492px',
  bigDesktop: '1119px',
}

export const ONE_HUNDRED_KB = 102400
